import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { keywordToRoute } from '../../service/routesMap/RoutesMap';
import { useSearch } from '../../service/SearchContext';
import { Notyf } from 'notyf';

const SearchBar = () => {

  const notyf = new Notyf({
    dismissible: true, ripple: false,
    duration: 1000,
    position: { x: 'rigth', y: 'top' },
    types: [
      {
        type: 'warning',
        background: 'orange',
        icon: { className: 'material-icons', tagName: 'i', text: 'warning' }
      },
      {
        type: 'error',
        background: 'DarkGoldenRod',
        duration: 3000,
        dismissible: true
      }
    ]
  });


  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const { setSearchTerm } = useSearch();

  const handleSearch = () => {
    const route = keywordToRoute[input.toLowerCase()];
    if (route) {
      setSearchTerm(input); // on garde le mot pour scroller après
      navigate(route);
    } else {
      notyf.error("Mot non trouvé dans le site.");
    }
  };

  return (

    <>
      {/* <input type="text" placeholder="Search here…" className="border border-gray-300 dark:bg-gray-800 rounded-full pl-4 pr-36 py-2 w-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary" />
            <button className="absolute right-1 top-1/2 -translate-y-1/2 customStyle   bg-blue-800 text-white rounded-full px-6 py-1.5 text-sm font-medium">Search</button> */}


      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Rechercher un mot..."
        className="border dark:border-gray-800 dark:bg-gray-900 rounded pl-4 pr-36 py-2 w-full placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <button onClick={handleSearch} className="absolute right-1 top-1/2 -translate-y-1/2 border border-gray-300 dark:border-gray-500 text-white   rounded  px-6 py-1.5 text-sm font-medium">
        <svg className="w-[22px] h-[22px] text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
        </svg>

      </button>

    </>
  );
};

export default SearchBar;
